// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RefineChangeIn } from './refineChangeIn.zod.ts';

export const refinementApplyInChangesMax = 60;

export const RefinementApplyIn = zod.object({
  "changes": zod.array(RefineChangeIn).min(1).max(refinementApplyInChangesMax),
  "revision": zod.int().min(1)
});

export type RefinementApplyIn = zod.input<typeof RefinementApplyIn>;
export type RefinementApplyInOutput = zod.output<typeof RefinementApplyIn>;
